
export type GetRecentOrders200OrdersItem = {
  amount?: number;
  createdAt?: string;
  orderId?: string;
  productName?: string;
  status?: string;
};
